module.exports = __webpack_public_path__ + "img/sign_position_seal_riding.a11f8029.png";